import instance from "../../utils/instance";

class UserService {
    async getUserOptions() {
        return await instance.get('/oa/common/CommonApi/GetZLSelectDict?dictionaryName=员工带部门显示&isFull=true');
    }
}

export default new UserService();